import { type FC } from 'react'
import { useCandidateSqlSearch } from 'recruiter/hooks'
import SendToSearch from './SendToSearch'

export const ResearchBulkActions: FC = () => {
    const { selectedCandidateIds } = useCandidateSqlSearch()

    return <SendToSearch selectedCandidates={selectedCandidateIds} />
}
